import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import IconButton from "components/elements/IconButton";
import dataProvider from "core/DataProvider";

const AddAccountManager = props => {
  const [activeTab, setActiveTab] = useState(0);
  const [formVisible, setFormVisible] = useState(false);

  const [id, setID] = useState(null);
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [mobile, setMobile] = useState("");

  const addUser = async () => {
    if (!name) {
      toast.error("Please enter a valid name");
      return;
    }

    if (!designation) {
      toast.error("Please enter a valid designation");
      return;
    }

    if (!mobile) {
      toast.error("Please enter a valid mobile number");
      return;
    }

    const data = {
      id: id ? id : 0,
      name,
      designation,
      mobile,
    };

    try {
      await dataProvider.network.post("masters/account-manager", data);

      setFormVisible(false);
      props.onComplete();
      toast.success(
        props.editUser
          ? "Account Manager modified successfully"
          : "Account Manager created successfully"
      );
    } catch (error) {
      console.error(error);
      toast.error(
        props.editUser
          ? "Failed to modify account manager"
          : "Failed to create account manager"
      );
    }
  };

  const tabData = [
    {
      title: "User Details",
      content: (
        <div className="tab-body">
          <div className="prow flex flex-v-center">
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Mobile"
                value={mobile}
                onChange={e => setMobile(e.target.value)}
              />
            </div>
          </div>
          <div className="prow flex flex-v-center">
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Designation"
                value={designation}
                onChange={e => setDesignation(e.target.value)}
              />
            </div>
          </div>
        </div>
      ),
    },
  ];

  const cancel = () => {
    setFormVisible(false);

    setID(null);
    setName("");
    setDesignation("");
    setMobile("");

    props.cancel();
  };

  // update view on edit user
  useEffect(() => {
    if (props.editUser) {
      setID(props.editUser.id);
      setName(props.editUser.name);
      setDesignation(props.editUser.designation);
      setMobile(props.editUser.mobile);

      setFormVisible(true);
    }
  }, [props.editUser]);

  return (
    <div style={{ marginTop: "1.5rem" }}>
      <div className="flex">
        <div className="right flex flex-v-center">
          {formVisible ? (
            <>
              <IconButton
                text={props.editUser ? "Update" : "Save"}
                onClick={addUser}
              />
              <IconButton text="Cancel" onClick={cancel} />
            </>
          ) : (
            <IconButton
              icon="add"
              text="New Account Manager"
              onClick={() => setFormVisible(true)}
            />
          )}
        </div>
      </div>
      {formVisible && (
        <div className="box mtop pad-1">
          <div className="tabs">
            {tabData.map((tab, index) => (
              <div
                key={index}
                className={activeTab === index ? "tab-head active" : "tab-head"}
                onClick={_ => setActiveTab(index)}
              >
                {tab.title}
              </div>
            ))}
          </div>
          <div className="tab-content">{tabData[activeTab].content}</div>
        </div>
      )}
    </div>
  );
};

export default AddAccountManager;
